import { readableColor } from 'polished';

const BASE_COLOUR = '#4a4a4a';
const LIGHT_COLOUR = '#d4d4d4';
const DARK_COLOUR = '#222222';

const createTheme = (additionalColours = {}) => {
  const { companyColour } = additionalColours;
  return {
    colours: {
      ...additionalColours,
      base: BASE_COLOUR,
      light: LIGHT_COLOUR,
      dark: DARK_COLOUR,
      readableColorOnMainColour: companyColour && readableColor(companyColour)
    }
  };
};

export default createTheme;
